/** Shared local-currency shortcut policy for trade and funding. Values are whole major units. */
export const USD_ANCHORS = [5, 10, 25, 50, 100, 250, 500, 1_000, 2_500];
export const QUICK_AMOUNTS_BY_CURRENCY = {
    USD: [5, 10, 25, 50, 100, 250],
    EUR: [5, 10, 25, 50, 100, 250],
    GBP: [5, 10, 25, 50, 100, 250],
    CHF: [5, 10, 25, 50, 100, 250],
    CAD: [5, 10, 25, 50, 100, 250],
    AUD: [5, 10, 25, 50, 100, 250],
    NZD: [10, 25, 50, 100, 250, 500],
    SGD: [5, 10, 25, 50, 100, 250],
    AED: [25, 50, 100, 250, 500, 1_000],
    SAR: [25, 50, 100, 250, 500, 1_000],
    BRL: [25, 50, 100, 250, 500, 1_000],
    PLN: [25, 50, 100, 250, 500, 1_000],
    MYR: [25, 50, 100, 250, 500, 1_000],
    CNY: [50, 100, 250, 500, 1_000, 2_500],
    HKD: [50, 100, 250, 500, 1_000, 2_500],
    SEK: [50, 100, 250, 500, 1_000, 2_500],
    NOK: [50, 100, 250, 500, 1_000, 2_500],
    CZK: [100, 250, 500, 1_000, 2_500, 5_000],
    MXN: [100, 250, 500, 1_000, 2_500, 5_000],
    ZAR: [100, 250, 500, 1_000, 2_500, 5_000],
    TWD: [250, 500, 1_000, 2_500, 5_000, 10_000],
    THB: [250, 500, 1_000, 2_500, 5_000, 10_000],
    PHP: [250, 500, 1_000, 2_500, 5_000, 10_000],
    TRY: [250, 500, 1_000, 2_500, 5_000, 10_000],
    INR: [500, 1_000, 2_500, 5_000, 10_000, 25_000],
    RUB: [500, 1_000, 2_500, 5_000, 10_000, 25_000],
    JPY: [500, 1_000, 2_500, 5_000, 10_000, 25_000],
    KRW: [5_000, 10_000, 25_000, 50_000, 100_000, 250_000],
    IDR: [50_000, 100_000, 250_000, 500_000, 1_000_000, 2_500_000], // ALLOW-D6-LITERAL: local IDR quick-amount tier, not a D6 scale
    VND: [100_000, 250_000, 500_000, 1_000_000, 2_500_000, 5_000_000], // ALLOW-D6-LITERAL: local VND quick-amount tier, not a D6 scale
};
